import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import DDOption from '../models/DropdownModels';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/apiConfig';

function CompanyDropdown({ onChangeDropdown }) {
    const [selectedCompanyOption, setSelectedCompanyOption] = useState(null);
    const [getCompanyOptions, setCompanyOptions] = useState([]);

    function handleChange(e) {
        setSelectedCompanyOption(e);
        if (onChangeDropdown) {
            onChangeDropdown(e);
        }
        // if(e !== null){
        //     setClientCompany((prevState) => ({
        //         ...prevState,
        //         ClientCompanyTypeId: e.value
        //     }));
        // } else {
        //     setClientCompany((prevState) => ({
        //         ...prevState,
        //         ClientCompanyTypeId: null
        //     }));
        // }
    };

    const fetchCompany = async () => {
        try {
            let selectedCompany = {
                UserId: localStorage.getItem("userId")
            };
            const response = await axios.get(getApiBaseUrl() + "/companylist", {params: selectedCompany});
            if (response.status === 200) {
                setCompanyDropdownData(response.data.data[0]);

            }
        } catch (error) {
            console.log(error);
        }
    };

    function setCompanyDropdownData(cct) {
        let allModuleOpt = [];
        allModuleOpt = cct.map(p => ({ value: p.CompanyId, label: p.CompanyName, name: p.CompanyName, description: '', isFixed: false, isDisabled: false, groupId: null }))
        setCompanyOptions(allModuleOpt);
    }

    useEffect(() => {
        if (!selectedCompanyOption && getCompanyOptions.length > 0) {
            const firstOption = getCompanyOptions[0];
            setSelectedCompanyOption(firstOption);
            if (onChangeDropdown) {
                onChangeDropdown(firstOption);
            }
        }
    }, [getCompanyOptions, onChangeDropdown, selectedCompanyOption]);

    useEffect(() => {
        fetchCompany();
    }, []);
    return (
        <div className="col-12">
            <div className="mb-3">
                <Select
                    name="CompanyId"
                    value={selectedCompanyOption ? selectedCompanyOption : []}
                    isClearable={false}
                    options={getCompanyOptions || []}
                    onChange={(e) => handleChange(e)}
                />
            </div>
        </div>
    )
}

export default CompanyDropdown